export default {
  cart: {
    title: 'Shopping Cart',
    list: {
      button1: ' Continue searching',
      button2: 'Send to ERP ',
      button3: 'Create Express Quote ',
    },
    tables: {
      table1: {
        row1: 'No information',
      },
      table2: {
        head: {
          header1: 'Image',
          header2: 'Item',
          header3: 'Supplier',
          header4: 'Price',
          header5: 'Quantity',
          header6: 'SubTotal',
        },
        foot: {
          total: 'Total $',
        },
      },
    },
    modal: {
      title: 'Stock & Lead time Confirmation',
      form: {
        option1: {
          message: 'Confirm vendor availability',
          measures: {
            kg: 'Kg',
            mt: 'Mt',
            unit: 'Unit',
          },
        },
        option2: {
          message: 'Request to the vendor if he can deliver on following date and location',
          delivery_location: {
            singapur: 'Singapore',
            hamburgo_germany: 'Hamburg / Germany',
            shangai: 'Shanghai',
            shenzhen: 'Shenzhen',
            busan: 'Busan',
            rashid_dubai: 'Rashid / Dubai',
            ningbo_china: 'Ningbo / China',
            guangzhou: 'Guangzhou',
            rotterdam_holanda: 'Rotterdam / Holland',
          },
        },
        option3: {
          message: 'Let the vendor propose a different date',
        },
        option4: {
          message: 'Time to respond',
        },
      },
    },
    script: {
      modalClose: {
        notify_message1: 'The data is being prepared.',
        notify_message2: 'Data submission completed.',
      },
      confirm: {
        message1: 'Are you sure you want to complete the operation?.',
        message2: 'Send to ERP',
        confirm_button: 'Continue',
        cancel_button: 'Cancel',
        then: {
          notify1: {
            title: 'Send to ERP',
            message: 'We are preparing the information to send.',
          },
          notify2: {
            title: 'Send to ERP',
            message: 'Information sending has been completed.',
          },
          notify3: {
            title: 'Shopping cart',
            message: 'The shopping cart is empty.',
          },
        },
        catch: 'Data submission canceled.',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/catalog/cart.js